var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManBeard6C(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type3_x5F_beards"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEA65F",
    d: "M360.1,375.5c-1.5,0-13.1,0.7-9.2,3.7c1.8,1.4,3.7,2.3,5.3,3.9c0.8,0.8,1.5,1.8,2.2,2.7 c0.5,0.8,0.2,2.4,1.2,2.7c1.4,0.5,3.2-3.7,4-4.8c1.4-1.8,2.9-3,4.6-4.4c2.5-2.1,0.4-2.4-1.8-3 C364.3,375.9,362.2,375.6,360.1,375.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEA65F",
    d: "M299.8,351.1c1.4,0.2,4.9-1.4,6.2-1.7c2.6-0.8,5.2-1.4,7.8-2c10-2.4,19.4-3.6,29.8-2.7 c5.8,0.5,11.4,2.7,17.4,2.5c5.9,0.2,11.6-2,17.4-2.5c10.4-0.9,19.9,0.3,29.8,2.7c2.6,0.6,5.2,1.2,7.8,2c1.2,0.4,4.8,1.9,6.2,1.7 c1.5-0.2-2.7-7-6.1-8.5c-8.9-4-20.3-4-29.3-5.8c-2.2-0.4-4.7-1.1-6.6-2c-2.7-1.2-2.8-1.3-5.4-0.3c-4.6,1.8-8.6,2.9-13.7,3 c-5.1-0.2-9.1-1.2-13.7-3c-2.7-1.1-2.8-1-5.4,0.3c-1.9,0.9-4.4,1.6-6.6,2c-9.1,1.8-20.4,1.8-29.3,5.8 C302.4,344.2,298.2,351,299.8,351.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEA65F",
    d: "M463.2,267.5c-1.2,20-6.1,34.8-16.3,54c-2.6,6.1-7.2,10.5-12.2,15.2c-2.6,4.1-5.5,9.5-6.9,14.1 c-2.9,9.6-10.2,15.2-18.5,20.7c-15.7,10.6-30.1,22-49.4,23.1c-0.6,0-1.1,0-1.5,0c-0.2,0-0.3,0-0.5,0c-20.2-0.2-34.2-12.5-50-23.2 c-8.3-5.6-15.6-11.1-18.5-20.7c-1.4-4.6-4.2-10-6.9-14.1c-5.1-4.7-9.6-9-12.2-15.2c-10.2-19.2-11.5-31.3-15.5-52.6 c-1.4,11.7-2.5,19.4-1.7,32.7c1.4,34,24.4,61,46.8,83.7c2,1.8,4.1,3.6,6.2,5.3c2.8,2.3,5.7,4.5,8.6,6.5c9.5,7,20.5,11.5,31.9,13.5 c2.9,0.5,5.8,0.8,8.7,1c16.1,2,30.6-2.5,43.6-10.4c2.6-1.6,5.1-3.3,7.6-5.1c5.5-4.4,10.9-9.1,16-14s10-10.2,14.5-15.6 c14.4-19,27.4-41,27.9-66.4C465.6,286.7,466.5,279.2,463.2,267.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManBeard6C);
export default __webpack_public_path__ + "static/media/man_beard_6c.c4fdbf2d4f555b69fa9f3c65372d45d3.svg";
export { ForwardRef as ReactComponent };